import {Box, Button, CircularProgress, Divider, IconButton, Stack, Typography} from "@mui/material";
import axios from "axios";
import {useEffect, useState} from "react";
import {FiEdit2, FiTrash2} from "react-icons/fi";
import {useLocation, useNavigate} from "react-router-dom";
import UserForm from "../components/Users/UserForm";
import UserInfo from "../components/Users/UserInfo";
import UserRolesGrid from "../components/Users/UserRolesGrid";
import UserTokensGrid from "../components/Users/UserTokensGrid";
import Window from "../components/Window/Window";
import useApiRequest from "../hooks/useApiRequest";

const AUTH_URL = process.env.REACT_APP_APIAUTH_BASE_URL;

const axiosInstance = axios.create({
  baseURL: AUTH_URL
});

const UserDetail = () => {
  const {state} = useLocation();
  const navigate = useNavigate();
  const id = state?.id;

  const isNewUser = !id;

  const {data, loading, read, remove} = useApiRequest(`/users`, !isNewUser);

  const [isEditing, setIsEditing] = useState(isNewUser);

  useEffect(() => {
    if (!isNewUser) {
      read(id);
    }
    // eslint-disable-next-line
  }, [id]);

  const handleEditToggle = () => {
    setIsEditing(!isEditing);
  };

  const handleDelete = async () => {
    const confirmDelete = window.confirm("¿Estás seguro de que deseas eliminar este usuario?");
    if (confirmDelete) {
      try {
        await remove(id);
        navigate("/users");
      } catch (error) {
        console.error("Error al eliminar el usuario:", error);
      }
    }
  };

  const handleResetPassword = async () => {
    const confirmReset = window.confirm(
      "¿Estás seguro de que deseas enviar un correo de cambio de contraseña a este usuario?"
    );
    if (confirmReset) {
      const url = `${AUTH_URL}/auth/reset-password`;

      await axiosInstance
        .post(url, {email: data.email})
        .then((response) => {
          console.log("Correo de reinicio de contraseña enviado con éxito");
        })
        .catch((error) => {
          console.error("Error al enviar el correo:", error);
        });
    }
  };

  return (
    <Window title={isNewUser ? "Nuevo Usuario" : "Detalles del Usuario"}>
      {loading && !isNewUser ? (
        <CircularProgress />
      ) : (
        <>
          <Stack direction="row" spacing={2} justifyContent={"space-between"}>
            {isEditing ? (
              <UserForm
                isNew={isNewUser}
                refreshData={() => read(id)}
                setIsEditing={setIsEditing}
                initialUserData={data}
              />
            ) : (
              <UserInfo user={data} />
            )}

            <Box>
              {!isNewUser &&
                (isEditing ? (
                  <Button variant="contained" color="primary" onClick={handleEditToggle}>
                    Cancelar
                  </Button>
                ) : (
                  <IconButton aria-label="edit" color="primary" onClick={handleEditToggle}>
                    <FiEdit2 />
                  </IconButton>
                ))}
              {!isNewUser && (
                <IconButton aria-label="delete" color="secondary" onClick={handleDelete}>
                  <FiTrash2 />
                </IconButton>
              )}
            </Box>
          </Stack>
          {!isNewUser && !isEditing && (
            <Button variant="contained" color="primary" onClick={handleResetPassword}>
              Reiniciar Contraseña
            </Button>
          )}

          {!isNewUser && (
            <>
              <Divider textAlign="left" sx={{mt: 2}}>
                <Typography variant="h4" sx={{color: "text.secondary"}}>
                  Roles
                </Typography>
              </Divider>
              <UserRolesGrid userId={id} />
            </>
          )}

          {!isNewUser && (
            <>
              <Divider textAlign="left" sx={{mt: 2}}>
                <Typography variant="h4" sx={{color: "text.secondary"}}>
                  Tokens
                </Typography>
              </Divider>
              <UserTokensGrid userId={id} />
            </>
          )}
        </>
      )}
    </Window>
  );
};

export default UserDetail;
